// Cookie banner. Choice is stored in localStorage under "valta-consent".
// The Meta Pixel loads on accept
// (window.valtaMetaGrant, defined by shared/_meta_pixel).
declare global {
  interface Window {
    valtaMetaGrant?: () => void
    valtaMetaFlushPending?: () => void
    valtaMetaDropPending?: () => void
  }
}

const KEY = 'valta-consent'
const banner = document.querySelector<HTMLElement>('[data-cookie-consent]')

function stored(): string | null {
  try {
    return localStorage.getItem(KEY)
  } catch {
    return null
  }
}

if (banner && !stored()) {
  banner.hidden = false
  banner.addEventListener('click', (event) => {
    const choice = (event.target as HTMLElement).closest<HTMLElement>('[data-consent]')?.dataset.consent
    if (!choice) return
    try {
      localStorage.setItem(KEY, choice)
    } catch {
      // Private mode: the banner shows again next visit.
    }
    if (choice === 'granted') {
      window.valtaMetaGrant?.()
      window.valtaMetaFlushPending?.()
    } else {
      window.valtaMetaDropPending?.()
    }
    banner.hidden = true
  })
}

export {}
